module.exports = __webpack_public_path__ + "static/img/settlement.d90bb638.png";